ACC.sessionpassword = {

  bindAll: function() {
    ACC.sessionpassword.bindForgotPasswordUrl();
  },

  bindForgotPasswordUrl: function() {
    if (window.location.search.slice(1) === 'resetpassword') {
      $.get($('.password-forgotten').data('url')).done(function(data) {
        $.colorbox({
          html: data,
          width: '100%',
          scrolling: false,
          height: 'auto',
          maxHeight: 300,
          maxWidth: '522px',
          close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
          overlayClose: false,
          onOpen: function() {
            $('#validEmail').remove();
          },
          onComplete: function() {
            $('.ph-resetpassword').removeClass('hidden');
            $('.ph-forgotpasswordlogin').addClass('hidden');
            $(this).colorbox.resize();
            $('#diffUrl').attr('value', true);
            ACC.common.refreshScreenReaderBuffer();
          },
          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      });
    }
  },

  bindChangePasswordDisplay: function() {
    if ($('.ph-loginRedirectToggle').length === 0) {
      $.get($('.ph-myprofile-changepassword').data('url')).done(function(data) {
        var $validPassword = $('#validPassword');

        $.colorbox({
          html: data,
          maxWidth: '500px',
          width: '100%',
          height: '75%;',
          overlayClose: false,
          close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
          onOpen: function() {
            $validPassword.remove();
          },
          onComplete: function() {
            $('.ph-securitytext').removeClass('hidden');
            $('#globalMessages').text('');

            if (navigator.appVersion.indexOf('Edge') !== -1) {
              $('.ph-formlabel').addClass('ph-formlabeledge');
            }

            ACC.profile.changePassword();

            var $changedPwd = $('#updatePasswordForm');

            $changedPwd.ajaxForm({
              success: function(result) {
                /* eslint-disable  unicorn/explicit-length-check */
                if ($(result).closest('#validPassword').length) {
                  /* eslint-enable  unicorn/explicit-length-check */
                  if ($validPassword.length === 0) {
                    $('#globalMessages').append(result).addClass('ph-encodedPassword-style');
                  }

                  $.colorbox.close();
                } else {
                  $changedPwd.find('.ph-page-profile').html($(result).find('#updatePasswordForm .ph-page-profile'));
                  $('#update-password').attr('disabled', true);

                  if (navigator.appVersion.indexOf('Edge') !== -1) {
                    $('.ph-formlabel').addClass('ph-formlabeledge');
                  }

                  ACC.profile.changePassword();
                }
              }
            });

            $(document).on('click', '#cboxContent #update-password', function() {
              if ($('.ph-isOneStore').html() === 'true' && $('.pageLabel-profile').length === 0) {
                ACC.cartReminder.cartReminderPopupMain();
              }
            });

            ACC.common.refreshScreenReaderBuffer();
          },
          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();

            if ($('.ph-isOneStore').html() === 'true' && $('.pageLabel-profile').length === 0) {
              ACC.cartReminder.cartReminderPopupMain();
            }

            ACC.sessionpassword.bindIntroTooltip();
          }
        });
      });
    }
  },

  bindIntroTooltip: function() {
    if ($('.ph-introjsvalue').text() === 'true') {
      if ($('.ph-showIntroToUser').text() === 'true') {
        ACC.introjs.bindFunction();
      }
    }
  },

  bindChangepasswordEncoded: function() {
    var changePasswordPopup = sessionStorage.getItem('changePasswordPopup');

    if ($('.ph-loggedIn').length <= 0) {
      sessionStorage.setItem('changePasswordPopup', null);
    }

    if (typeof Storage !== 'undefined' && $('.ph-encodedType').attr('data-encodeValue') === 'true' && (changePasswordPopup === null || changePasswordPopup !== 'false')) {
      sessionStorage.setItem('changePasswordPopup', false);
      ACC.sessionpassword.bindChangePasswordDisplay();
    }
  }
};

$(document).ready(function() {
  ACC.sessionpassword.bindAll();

  if ($('.ph-loginRedirectToggle').length === 0) {
    ACC.sessionpassword.bindChangepasswordEncoded();
  }
});
